import { cn } from "@/lib/utils";

import type { ResaltadoDeUnaFila } from "./resaltado";

/* ---------------------------------------------------------------------------
   Las marcas con que una pestaña señala lo que llegó en una sincronización
   resaltada. Todo sale de los tokens `sync-*` de `app.css` (claro y oscuro).

   Resaltar nunca cambia el orden ni esconde nada: solo pinta. Cada elemento
   resaltado lleva `data-syhl="1"` (y el resto "0") para que "Ir al primero" lo
   encuentre sin saber en qué pestaña está.
--------------------------------------------------------------------------- */

/** El atributo con que "Ir al primero" encuentra lo resaltado. */
export const atributoDeResaltado = (on: boolean) => ({ "data-syhl": on ? "1" : "0" }) as const;

/** La fila de una tabla: fondo ámbar; el primer renglón de celdas lleva además la barra. */
export const CLASE_DE_FILA_RESALTADA = "bg-sync-highlight hover:bg-sync-highlight";
export const CLASE_DE_PRIMERA_CELDA_RESALTADA = "shadow-[inset_3px_0_0_0_var(--sync-accent)]";

/** Una tarjeta de texto o de audio. */
export const CLASE_DE_TARJETA_RESALTADA = "bg-sync-highlight border-sync-highlight-border";

/** Una fotografía: el aro ámbar por fuera, sin tocar su tamaño. */
export const CLASE_DE_FOTO_RESALTADA = "shadow-[0_0_0_2.5px_var(--sync-accent)]";

export function claseSi(on: boolean, clase: string): string | undefined {
  return on ? clase : undefined;
}

/** "SINC. 09:12", o "SINC. 10:32 · 09:12" si lo tocaron varias. */
export function TagDeSincronizacion({
  horas,
  className,
}: {
  horas: string[];
  className?: string;
}) {
  if (horas.length === 0) return null;

  return (
    <span
      className={cn(
        "bg-sync-tag text-sync-tag-foreground flex-none rounded-[4px] px-[5px] py-px font-mono text-[0.5625rem] font-extrabold tracking-[0.04em] whitespace-nowrap",
        className,
      )}
    >
      SINC. {horas.join(" · ")}
    </span>
  );
}

/**
 * Todo lo que una fila de tabla necesita para resaltarse: el atributo para
 * encontrarla, el fondo de la fila, la barra de su primera celda y el rótulo
 * «SINC. 09:12» que va junto al nombre.
 */
export function marcaDeFila(r: ResaltadoDeUnaFila) {
  return {
    on: r.on,
    atributo: atributoDeResaltado(r.on),
    claseFila: claseSi(r.on, CLASE_DE_FILA_RESALTADA),
    claseCelda: claseSi(r.on, CLASE_DE_PRIMERA_CELDA_RESALTADA),
    tag: <TagDeSincronizacion horas={r.horas} />,
  };
}
